<template>
    <div class="courseList">
        <div class="filterArea" style="padding-left: 12px;">
            <span class="textLabel yellowTextLabel" :class="{active : timeFilterItem.id == selectedTimeFilter}"
                  v-for="timeFilterItem in timeFilterTypeList" :key="timeFilterItem.id"
                  @click="changeTimeFilter(timeFilterItem)">
                {{timeFilterItem.title}}
            </span>
        </div>

        <div class="list marginT24 paddingH16">
            <div class="item white_bg" v-for="dataItem in dataList"
                 :key="dataItem.id" data-click="viewItem(dataItem)">

                <div class="inner padding12">
                   <div class="darkgrey101010 font18r">分销员姓名：{{dataItem.userName}}</div>
                   <div class="marginT8 color777 font14r">分销ID：{{dataItem.introduceCode}}</div>
<!--                   <div class="marginT8 color777 font14r">分销昵称：{{dataItem.userName}}</div>-->
                   <div class="marginT8 color777 font14r">开通时间：{{formatDate(dataItem.createTime)}}</div>
                </div>

            </div>
        </div>

        <div class="alignCenter colorCCC bold paddingV16" v-show="status == 'ready' && dataList.length < 1">
            <img src="notice/no_content.png" width="206" height="143" alt="暂时没有任何内容" />
        </div>

    </div>
</template>

<script>
import generalCmpPart from "@comp/part/generalCmpPart";
import appHelper from "@util/appHelper";

//
import moment from "moment";


const config = {
    apiConfig : {
        list : {
            url : 'portal/v2/distribution/salesman/getSubordinateList',
            dataPath : 'data.records',
            totalPath : 'data.total',
            totalPagePath : 'data.pages',
        }
    }
}

export default {
    extends : generalCmpPart,
    components : {  },
    data() {
        return {
            apiConfig : config.apiConfig,

            enableDataList : true,
            autoLoadDataList : true,

            timeFilterTypeList : [{
                title : '全部',
                id : null
            },{
                title : '今日',
                id : 1
            },{
                title : '本周',
                id : 2
            },{
                title : '本月',
                id : 3
            }],
            selectedTimeFilter : null,
            filters : {
                range : 0
            },

            activeDataItem : null
        }
    },
    methods : {
        changeTimeFilter(item) {
            this.selectedTimeFilter = this.filters.range = item.id;
            this.reloadDataList();
        },
        viewItem(dataItem) {
            appHelper.redirect('/liveTelecast/' + dataItem.id);
        },
        viewIncome(dataItem) {
            this.activeDataItem = dataItem;
            this.$refs.viewInComeDrawer.open();
        },
        formatDateTime(timestamp) {
            return moment(timestamp).format('YYYY-MM-DD HH:mm');
        }
    },
    mounted() {
        // for (let i=0; i<3; i++)
        // {
        //     this.dataList.push({
        //         id : i,
        //         title : 'weherherh',
        //         price : '9.9',
        //         segmentCount : 3,
        //         learnCount: 284,
        //         createTime : new Date().getTime(),
        //         coverImg : appHelper.getRandomCoverImage()
        //     });
        // }
    }
}
</script>

<style lang="scss" scoped>
.red {
    color: #F42418;
}
.grey777 {
    color: #777;
}
.darkgrey101010 {
    color: #101010;
}
.filterArea {
    .textLabel {
        width: 56px;
        height: 22px;
        line-height: 22px;
        border: none;
        padding: 0;
        border-radius: 12px;
        margin-right: 16px;
        background-color: hsla(230, 30%, 96%, 1);
        text-align: center;
        font-size: 14px;
        color: hsla(219, 9%, 39%, 1);
        &.active {
            background-color: hsla(36, 100%, 57%, 1);
            color: white;
        }
    }
}
.list {
    .item {
        border: solid 1px #BBBBBB;
    }
}
</style>
